import { graphql } from '~/__gql__';

export const mutationRequestMessageTemplatesUpsell = graphql(/* GraphQL */ `
  mutation RequestMessageTemplatesUpsell {
    requestCompanyTemplatesUpsell
  }
`);
